module.exports = __webpack_public_path__ + "img/7565418c12fcc2d53ce0614325fb7974.8d3d194e.jpg";